/**
 * NLP Models Case Study Specific Logic
 * Currently mostly handled by the generic caseStudyDetail.js
 */

import { isEditModeActive } from './sanity-client';

document.addEventListener('DOMContentLoaded', () => {
    // We could add page-specific animations or tracking here
    if (isEditModeActive()) {
        console.log('NLP Models Case Study Edit Mode Active');
    }
});
